import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import userTokenService from '../../common/services/security/userTokenService';
import { getUserRole } from '../../common/redux/security/loggedInUser/loggedInUserSlice';

const ShowForPermissions = ({
  projectId,
  permissions,
  children,
  noPermissionsView = null,
}) => {
  const [hasProjectPermission, setHasProjectPermission] = useState(false);
  const userRole = useSelector(getUserRole);

  useEffect(() => {
    const hasPermission = userTokenService.hasProjectPermission(
      projectId,
      permissions,
      userRole
    );
    setHasProjectPermission(hasPermission);
  }, [projectId, permissions, setHasProjectPermission, userRole]);

  if (hasProjectPermission) {
    return children;
  }

  return noPermissionsView;
};

ShowForPermissions.propTypes = {
  projectId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  permissions: PropTypes.arrayOf(PropTypes.string),
};

export default ShowForPermissions;
